// src/services/adminApi.ts
import api from "./api"; // seu axios configurado com baseURL e token

// ─── Resumo ──────────────────────────────────────────────────────────────────
export const fetchResumo = () =>
  api.get("/superadmin/resumo").then((r) => r.data.data);

// ─── Usuários ────────────────────────────────────────────────────────────────
export const fetchUsuarios = (search = "", modulo = "") =>
  api
    .get("/superadmin/usuarios", { params: { search, modulo } })
    .then((r) => r.data.data);

// ─── Usuários temporários ────────────────────────────────────────────────────
export const fetchUsuariosTemporarios = (search = "", status = "") =>
  api
    .get("/superadmin/usuarios-temporarios", { params: { search, status } })
    .then((r) => r.data.data);

// ─── Fazendas ─────────────────────────────────────────────────────────────────
export const fetchFazendas = (search = "") =>
  api
    .get("/superadmin/fazendas", { params: { search } })
    .then((r) => r.data.data);

// ─── Contatos WhatsApp ────────────────────────────────────────────────────────
export const fetchContatosWhatsapp = (search = "") =>
  api
    .get("/superadmin/whatsapp/contatos", { params: { search } })
    .then((r) => r.data.data);

// ─── Mensagens de um contato ─────────────────────────────────────────────────
export const fetchMensagensContato = (uid_whatsapp_contato: string) =>
  api
    .get(`/superadmin/whatsapp/contatos/${uid_whatsapp_contato}/mensagens`)
    .then((r) => r.data.data);
